import { render, staticRenderFns } from "./MaintenanceReports.vue?vue&type=template&id=66010c3f&scoped=true"
import script from "./MaintenanceReports.vue?vue&type=script&lang=js"
export * from "./MaintenanceReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66010c3f",
  null
  
)

export default component.exports